import { IWorkflowDefinition, IWorkflowQuestion } from "./workflow";

export enum DemandStateType {
  New = "new",
  Finished = "finished",
  Canceled = "canceled",
}

export enum DemandPriorityType {
  Low = "low",
  Medium = "medium",
  High = "high",
}

export enum DemandStateFilterType {
  All = "all",
  New = "new",
  AfterDeadline = "afterDeadline",
  NotAssigned = "notAssigned",
  NotAssignedAfterDeadline = "notAssignedAfterDeadline",
  AssignedAfterDeadline = "assignedAfterDeadline",
  Finished = "finished",
  Canceled = "canceled",
}

export interface IDemandItem {
  id: number;
  name: string;
  state: DemandStateType;
  createdAt: Date;
  deadLine: Date;
  priority: DemandPriorityType;
  clientName?: string | null;
  assignedName?: string | null;
  isUserAssigned: boolean;
}

export interface IDemandConversationMessageUser {
  id: number;
  name: string;
}

export interface IDemandConversationMessage {
  text: string;
  userIds: number[] | null;
  requestedRoleId: number | null;
}

export interface IDemandConversationMessages {
  id: number;
  text: string;
  createdAt: Date;
  createdByUser: IDemandConversationMessageUser;
  sentUsers: IDemandConversationMessageUser[];
  requestedRoleId: number;
  canDelete: boolean;
}

export interface IDemand {
  id: number;
  idWorkflowDefinitionItem: number;
  name: string;
  state: DemandStateType;
  priority: DemandPriorityType;
  deadLine: Date;
  createdAt?: Date | null;

  assignedUserId?: number | null;
  assignedUserName?: string | null;
  canChangeAssignedUser: boolean;
  userCreator?: string | null;

  assignedGroupId?: number | null;
  assignedGroupName?: string | null;
  canChangeAssignedGroup: boolean;

  clientId?: number | null;
  clientName?: string | null;

  canTake: boolean;
  conversationMessage: IDemandConversationMessage | null;
  conversationMessages: IDemandConversationMessages[];
  questions: IWorkflowQuestion[];
}

export interface IDemandHistory {
  definition: IWorkflowDefinition[];
  demands: IDemandHistoryItem[];
}

export interface IDemandHistoryItem {
  id: number;
  idWorkflowDefinitionItem: number;
  state: DemandStateType;
  createdAt: Date;
  finishedAt?: Date | null;
  userFinishedId?: number | null;
  userFinishedName?: string | null;
  hasRights: boolean;
}
